import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import classes from "./BarChartComponent.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const data = {
  labels: ["2018", "2019", "2020", "2021", "2022", "2023"],
  datasets: [
    {
      label: "oquvchilar",
      data: [2400, 2502, 2909, 2861, 2481, 2712],
      backgroundColor: ["#66B5EF", "#32C179", "#F2CE06", "#F74A8A", "#FF8C00"],
      borderWidth: 1,
    },
  ],
};

export default function BarChartComponent() {
  return (
    <div className={classes["bar-chart-wrapper"]}>
      <h2 className={classes["title"]}>Number of students</h2>
      <Bar data={data} />
    </div>
  );
}
